import { createStore, combineReducers } from 'redux';
import { appReducer, employeeOrderConfigReducer } from './redux-reducers';
import { loadState, saveState } from './local-storage';

const rootReducer = combineReducers({
  app: appReducer,
  employeeOrderConfig: employeeOrderConfigReducer
});
const store = createStore(rootReducer, loadState());

store.subscribe(saveState);

export default store;
